import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "adddownloadableproductstocart-mutation"
    }}>{`addDownloadableProductsToCart mutation`}</h1>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`We recommend using the `}<a parentName="p" {...{
        "href": "add-products.md"
      }}>{`addProductsToCart mutation`}</a>{` to add any type of product to the cart.`}</p>
    <p>{`A downloadable product can be anything that you can deliver as a file, such as an eBook, music, video, software application, or an update. To add a downloadable product to a cart, you must provide the cart ID, the SKU, and the quantity. In some cases, you must include the IDs for downloadable product links. You can also optionally specify customizable options.`}</p>
    <h2 {...{
      "id": "syntax"
    }}>{`Syntax`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation: {
    addDownloadableProductsToCart(
        input: AddDownloadableProductsToCartInput
    ): {
        AddDownloadableProductsToCartOutput
    }
}
`}</code></pre>
    <h2 {...{
      "id": "reference"
    }}>{`Reference`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#mutation-addDownloadableProductsToCart"
      }}><inlineCode parentName="a">{`addDownloadableProductsToCart`}</inlineCode></a>{` reference provides detailed information about the types and fields defined in this mutation.`}</p>
    <h2 {...{
      "id": "example-usage"
    }}>{`Example usage`}</h2>
    <p>{`The following examples show how to add a downloadable product to a shopping cart , depending on whether the `}<strong parentName="p">{`Links can be purchased separately`}</strong>{` option is selected on the `}<strong parentName="p">{`Downloadable Information`}</strong>{` section of the product page.`}</p>
    <h3 {...{
      "id": "add-a-downloadable-product-to-a-cart-with-links-can-be-purchased-separately-enabled"
    }}>{`Add a downloadable product to a cart with `}<inlineCode parentName="h3">{`Links can be purchased separately`}</inlineCode>{` enabled`}</h3>
    <p>{`The following example shows how to add a downloadable product in which the `}<strong parentName="p">{`Links can be purchased separately`}</strong>{` option is enabled. The payload includes custom downloadable links `}<inlineCode parentName="p">{`Episode 2`}</inlineCode>{` and `}<inlineCode parentName="p">{`Episode 3`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`Request:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation {
  addDownloadableProductsToCart(
    input: {
      cart_id: "gMV2BFQuNGiQmTnepQlMGko7Xc4P3X1w"
      cart_items: {
        data: {
          sku: "240-LV09"
          quantity: 1
        }
        downloadable_product_links: [
          {
            link_id: 7                 # Episode 2
          }
          {
            link_id: 8                 # Episode 3
          }
        ]
      }
    }
  ) {
    cart {
      itemsV2 {
        items {
          product {
            sku
          }
          quantity
          ... on DownloadableCartItem {
            links {
              title
              price
            }
            samples {
              title
              sample_url
            }
          }
        }
        total_count
        page_info {
          page_size
          current_page
          total_pages
        }
      }
    }
  }
}
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "data": {
    "addDownloadableProductsToCart": {
      "cart": {
        "itemsV2": {
          "items": [
            {
              "product": {
                "sku": "240-LV09"
              },
              "quantity": 1,
              "links": [
                {
                  "title": "Episode 2",
                  "price": 9
                },
                {
                  "title": "Episode 3",
                  "price": 9
                }
              ],
              "samples": [
                {
                  "title": "Trailer #1",
                  "sample_url": "https://<M2_INSTANCE>/downloadable/download/sample/sample_id/16/"
                },
                {
                  "title": "Trailer #2",
                  "sample_url": "https://<M2_INSTANCE>/downloadable/download/sample/sample_id/17/"
                },
                {
                  "title": "Trailer #3",
                  "sample_url": "https://<M2_INSTANCE>/downloadable/download/sample/sample_id/18/"
                }
              ]
            }
          ],
          "total_count": 1,
          "page_info": {
            "page_size": 20,
            "current_page": 1,
            "total_pages": 1
          }
        }
      }
    }
  }
}
`}</code></pre>
    <h3 {...{
      "id": "add-a-downloadable-product-to-a-cart-with-disabled-links-can-be-purchased-separately"
    }}>{`Add a downloadable product to a cart with disabled `}<inlineCode parentName="h3">{`Links can be purchased separately`}</inlineCode></h3>
    <p>{`The following example shows how to add a downloadable product in which the `}<strong parentName="p">{`Links can be purchased separately`}</strong>{` option is disabled. All downloadable links are added to the cart automatically.`}</p>
    <p><strong parentName="p">{`Request:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation {
  addDownloadableProductsToCart(
    input: {
      cart_id: "gMV2BFQuNGiQmTnepQlMGko7Xc4P3X1w"
      cart_items: {
        data: {
          sku: "240-LV07"
          quantity: 1
        }
      }
    }
  ) {
    cart {
      itemsV2 {
        items {
          product {
            sku
          }
          quantity
          ... on DownloadableCartItem {
            links {
              title
              price
            }
            samples {
              title
              sample_url
            }
          }
        }
        total_count
        page_info {
          page_size
          current_page
          total_pages
        }
      }
    }
  }
}
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "data": {
    "addDownloadableProductsToCart": {
      "cart": {
        "itemsV2": {
          "items": [
            {
              "product": {
                "sku": "240-LV07"
              },
              "quantity": 2,
              "links": [
                {
                  "title": "Solo Power Circuit",
                  "price": 14
                }
              ],
              "samples": [
                {
                  "title": "Trailer #1",
                  "sample_url": "https://<M2_INSTANCE>/downloadable/download/sample/sample_id/10/"
                },
                {
                  "title": "Trailer #2",
                  "sample_url": "https://<M2_INSTANCE>/downloadable/download/sample/sample_id/11/"
                },
                {
                  "title": "Trailer #3",
                  "sample_url": "https://<M2_INSTANCE>/downloadable/download/sample/sample_id/12/"
                }
              ]
            }
          ],
          "total_count": 1,
          "page_info": {
            "page_size": 20,
            "current_page": 1,
            "total_pages": 1
          }          
        }
      }
    }
  }
}
`}</code></pre>
    <h2 {...{
      "id": "errors"
    }}>{`Errors`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Error`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Could not find a cart with ID "XXX"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The specified `}<inlineCode parentName="td">{`cart_id`}</inlineCode>{` value does not exist in the `}<inlineCode parentName="td">{`quote_id_mask`}</inlineCode>{` database table.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Could not find a product with SKU "YYY"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A product with the SKU specified in the `}<inlineCode parentName="td">{`data`}</inlineCode>{`.`}<inlineCode parentName="td">{`sku`}</inlineCode>{` argument does not exist.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Required parameter "cart_id" is missing`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The mutation does not contain a `}<inlineCode parentName="td">{`cart_id`}</inlineCode>{` argument.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Required parameter "cart_items" is missing`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The `}<inlineCode parentName="td">{`cart_items`}</inlineCode>{` argument is empty or is not of type `}<inlineCode parentName="td">{`array`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Please specify product link(s).`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`You tried to add a downloadable product in which the `}<inlineCode parentName="td">{`Links can be purchased separately`}</inlineCode>{` option is enabled, but you did not specify individual product links.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      